import { createContext } from 'react';
export var secondaryDimensionListContext = createContext([]);
